module.exports = __webpack_public_path__ + "media/images/850/about-8a6ffbb35e8d1cc1f162a2602eaf9eba.webp";